export class CodingSystem {
    element: string;
    value: string;
}
